import { z } from "zod"

export const addressSchema = z.object({
  addressTitle: z
    .string()
    .trim()
    .min(1, "Address title is required")
    .min(2, "Address title must be at least 2 characters")
    .max(50, "Address title must not exceed 50 characters"),

  addressLine1: z
    .string()
    .trim()
    .min(1, "Address Line 1 is required")
    .min(3, "Address must be at least 3 characters")
    .max(150, "Address must not exceed 150 characters"),

  addressLine2: z
    .string()
    .trim()
    .max(150, "Address must not exceed 150 characters")
    .optional()
    .or(z.literal("")),

  addressCity: z
    .any()
    .refine((val) => val !== null && val !== undefined && val !== "", {
      message: "City is required",
    }),

  addressState: z
    .string()
    .trim()
    .min(1, "State / Region is required")
    .min(2, "State must be at least 2 characters")
    .max(85, "State must not exceed 85 characters")
    .regex(/^[\p{L}\s'-]+$/u, "State can only contain letters, spaces, hyphens, and apostrophes"),

  addressPostalCode: z
    .string()
    .trim()
    .min(1, "Postal code is required")
    .min(3, "Postal code must be at least 3 characters")
    .max(10, "Postal code must not exceed 10 characters")
    .regex(/^[a-zA-Z0-9\s-]+$/, "Postal code can only contain letters, numbers, spaces, and hyphens"),

  addressCountry: z
    .string()
    .trim()
    .min(1, "Country is required")
    .max(56, "Country name must not exceed 56 characters"),

  addressIsDefault: z.boolean().optional().default(false),
})

export type AddressFormValues = z.infer<typeof addressSchema>
